<template>
  <div class="containers">
    <div v-if="goArea == true" class="area-list">
      <CAlert
          v-if="success == true"
          :show.sync="currentAlertCounter"
          closeButton
          style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
      >
        {{ alertMess }}
      </CAlert>
      <CAlert
          v-else
          :show.sync="currentAlertCounter"
          closeButton
          style="background-color:red;border-radius:0;text-align:center;color:white"
      >
        {{ alertMess }}
      </CAlert>
      <div class="search-area">
        <CRow>
          <CCol sm="10" class="pr-1 pl-1">
            <input type="text" placeholder="Tipe Pegawai" v-model="searchKeterangan" class="form-control"/>
          </CCol>
          <CCol sm="2">
            <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
          </CCol>
        </CRow>
      </div>
      <div class="sticky1">
        <CRow>
          <CCol sm="4"></CCol>
          <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon
                            :icon="{prefix: 'fas', iconName: 'chevron-left'}"/></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon
                            :icon="{prefix: 'fas', iconName: 'chevron-left'}"/></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon
                            :icon="{prefix: 'fas', iconName: 'chevron-right'}"/></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon
                            :icon="{prefix: 'fas', iconName: 'chevron-right'}"/></CButton>
                    </span>
            <input @change="validatePage(page)" v-if="totalPage != 1"
                   style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page"
                   class="text-center rounded p-1" type="text">
            <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right"
                   v-model="page" class="text-center rounded p-1" type="text">
            <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span
                style="color:rgba(16, 16, 16, 1)">{{ firstPage }} - {{ lastPage }}</span> of {{ totalRow }}</span>
            <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
            <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px"
                 style="float:right;cursor:pointer"/>
          </CCol>
          <CCol sm="2">
            <CButton @click="moving()" type="button" class="btn btn-add">Tambah</CButton>
          </CCol>
        </CRow>
      </div>
      <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable"
              :errors="errorMessage"></Tables>
    </div>
    <div v-else class="area-edit">
      <CRow class="area-back">
        <CCol sm="12">
          <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px"
               style="float:left;cursor:pointer"/>
        </CCol>
      </CRow>
      <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
      <CRow class="area-input">
        <CCol sm="12">
          <CRow>
            <CCol sm="6">
              <label>Nama Tipe Pegawai</label>
              <input
                  class="form-control"
                  v-model.trim="$v.keterangan.$model"
                  :class="{ 'is-invalid':$v.keterangan.$error, 'is-valid': !$v.keterangan.$invalid }"
                  placeholder="Nama Tipe Pegawai"
                  type="text"
              />
            </CCol>
            <CCol sm="6">
              <label>ID ERP</label>
              <input
                  class="form-control"
                  v-model="idErp"
                  placeholder="ID ERP"
                  type="text"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="6">
              <div>
                <input type="checkbox" id="isPegawai" name="isPegawai" @change="checkType('isPegawai')"
                       :checked="isPegawai == 1">
                <label for="isPegawai">Pegawai </label>
              </div>
              <div>
                <input type="checkbox" id="type" name="type" @change="checkType('type')" :checked="type == 1">
                <label for="type">Outsourcing </label>
              </div>
            </CCol>
          </CRow>
        </CCol>
      </CRow>
      <CRow class="area-button-submit">
        <CCol sm="12">
          <CButton @click="moving()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
          <CButton @click="submitForm()" class="btn btn-edit-submit">
            <span v-if="loading == false">Submit</span>
            <CSpinner v-else color="default" size="sm"/>
          </CButton>
        </CCol>
      </CRow>
    </div>
  </div>
</template>

<script>
import Tables from '../../../component/tablePresensi'
import {DataApi} from "../../../service/DataApi";
import {ModelSelect} from 'vue-search-select'
import {required} from 'vuelidate/lib/validators'
import {validationMixin} from 'vuelidate'

export default {
  components: {
    ModelSelect,
    Tables
  },
  mixins: [validationMixin],
  validations: {
    keterangan: {
      required
    }
  },
  data() {
    return {
      success: true,
      // datas
      refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
      moreIcon: require('../../../assets/menu/icon_more.svg'),
      backIcon: require('../../../assets/menu/icon_goback.svg'),
      dataTh: ['Nama Tipe Pegawai', 'Action'],
      dataTd: ['keterangan', 'action'],
      styleTable: ['300px', '100px'],
      classReload: 'reloadOff',
      datas: [],
      goArea: true,
      loading: false,
      alertMess: '',
      currentAlertCounter: 0,

      // data model
      keterangan: '',
      kode: "",
      idErp: "",
      unix: "",
      tipe: 'C',
      type: 0,
      isPegawai: 0,

      // paging
      page: 1,
      size: 20,
      totalRow: 0,
      totalPage: 1,
      firstPage: 0,
      lastPage: 0,

      // filter
      searchKeterangan: '',
      // error
      errorMessage: '',
      flagSearch: false
    }
  },
  watch: {
    page() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    searchKeterangan() {
      this.flagSearch = true
    },
    goArea() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
  },
  computed: {},
  methods: {
    checkType(elementId) {
      let type = document.getElementById(elementId)
      switch (elementId) {
        case 'type':
          this.type = type.checked == true ? 1 : 0
          break;
        case 'isPegawai':
          this.isPegawai = type.checked == true ? 1 : 0
          break;
      }
    },
    /**
     * GET DATA
     */
    sorting(value) {
      if (value == 0) {
        function compare(a, b) {
          if (a.kode.toLowerCase() < b.kode.toLowerCase()) {
            return -1
          }
          if (a.kode.toLowerCase() > b.kode.toLowerCase()) {
            return 1
          }
          return 0
        }

        return this.datas.sort(compare)
      } else if (value == 1) {
        function compare(a, b) {
          if (a.keterangan.toLowerCase() < b.keterangan.toLowerCase()) {
            return -1
          }
          if (a.keterangan.toLowerCase() > b.keterangan.toLowerCase()) {
            return 1
          }
          return 0
        }

        return this.datas.sort(compare)
      }
    },
    getData() {
      if (this.flagSearch == true) {
        this.page = 1
      }
      this.$store.state.loadingScreen = true
      let keterangan = this.searchKeterangan
      let payload = {
        keterangan: keterangan,
        limit: this.size,
        pageIn: this.page
      }
      DataApi.post("pegawai/status/lihat", payload)
          .then(res => {
            let response = res.data
            if (response.success == true) {
              this.datas = response.data.data
              this.totalRow = response.data.totalRow
              this.firstPage = (((this.page - 1) * this.size) + 1)
              this.lastPage = (((this.page - 1) * this.size) + this.datas.length)
              this.totalPage = Math.floor(this.totalRow / this.size)
              let modAr = this.totalRow % this.size
              if (modAr != 0) {
                this.totalPage = this.totalPage + 1
              } else {
                //
              }
            } else {
              this.datas = []
              this.totalRow = 0
              this.firstPage = 0
              this.lastPage = 0
              this.totalPage = 1
              this.errorMessage = response.message
            }
            this.flagSearch = false
            this.$store.state.loadingScreen = false
          })
    },
    findData() {
      this.getData()
    },
    reload() {
      this.searchKeterangan = ''
      this.flagSearch = true
      this.getData()
      if (this.classReload == 'reloadOff') {
        this.classReload = 'reloadOn'
      } else {
        this.classReload = 'reloadOff'
      }
    },
    movePage(direction) {
      if (direction == 'prev') {
        this.page = this.page - 1
      } else {
        this.page = this.page + 1
      }
      this.getData
    },
    validatePage(page) {
      if (page > this.totalPage) {
        this.page = this.totalPage
      }
    },

    /**
     * ADD DATA
     */
    moving() {
      setTimeout(this.moveArea, 600);
    },
    moveArea() {
      if (this.goArea == true) {
        this.goArea = false
      } else {
        this.goArea = true
        this.keterangan = ''
        this.kode = ''
        this.tipe = 'C'
        this.type = 0
        this.$v.$reset()
      }
    },
    goSave() {
      let keterangan = this.keterangan
      let kode = parseInt(this.kode)
      let tipe = this.tipe
      let unix = this.unix
      let idErp = this.idErp
      let pjtk = ''
      if (this.type == 1) {
        pjtk = 'Y'
      } else {
        pjtk = 'T'
      }
      let pegawai = ''
      if (this.isPegawai == 1) {
        pegawai = 'Y'
      } else {
        pegawai = 'T'
      }

      let payload = {
        keterangan: keterangan,
        kode: kode,
        pjtk: pjtk,
        idERP: idErp,
        pegawai: pegawai,
        tipe: tipe,
        unix: unix
      }
      DataApi.post("pegawai/status/simpan", payload)
          .then(res => {
            let response = res.data
            if (response.success == true) {
              if (response.data.Data1 == 'Y') {
                this.success = true
              } else {
                this.success = false
              }
              this.alertMess = response.data.Data2
            } else {
              this.alertMess = response.message
              this.success = false
            }
            this.getData()
            this.moving()
            this.loading = false
            this.currentAlertCounter = 7
          })
    },

    /**
     * EDIT DATA
     */
    editData(value) {
      let generate = this.datas[value]
      this.keterangan = generate.keterangan
      this.unix = generate.unix
      this.kode = generate.kode
      this.idErp = generate.idERP == 'null' ? null : generate.idERP
      if (generate.pjtk == 'Y') {
        this.type = 1
      } else {
        this.type = 0
      }
      if (generate.pegawai == 'Y') {
        this.isPegawai = 1
      } else {
        this.isPegawai = 0
      }
      this.tipe = 'u'
      this.moving()
    },
    submitForm() {
      this.$v.$touch()
      if (this.$v.$invalid) {
      } else {
        this.goSave()
        this.loading = true
      }
    },

  },
  mounted() {
    this.errorMessage = 'Find Your Data'
  }
}
</script>
<style scoped>
.containers {
  background-color: white;
  border-bottom: 1px solid #e5e6e8;
}

.autocomplete {
  width: 100%;
  position: relative;
}

.input {
  cursor: text;
}

.close {
  position: absolute;
  right: 8px;
  top: 10px;
  background: none;
  border: none;
  font-size: 14px;
  color: lightgrey;
  cursor: pointer;
}

.placeholder {
  position: absolute;
  top: 7px;
  left: 16px;
  font-size: 14px;
  color: #d0d0d0;
}

.popovers {
  text-align: center;
  width: 100% !important;
  min-height: 50px;
  border: 1px solid #d8dbe0;
  position: absolute;
  top: 35px;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 8px;
  left: 0;
  right: 0;
  background: #fff;
  border-radius: 3px;
  text-align: center;
  z-index: 3;
}

.popovers input {
  right: 8px;
  left: 8px;
  width: 100%;
}

.options {
  max-height: 200px;
  overflow-y: auto;
  margin-top: 5px;
}

.options ul {
  list-style-type: none;
  text-align: left;
  padding-left: 0;
}

.options ul li {
  border-bottom: 1px solid lightgrey;
  padding: 10px;
  cursor: pointer;
  background: white;
}

.options ul li:first-child {
  border-top: 1px solid lightgray;
}

.options ul li:not(.selected):hover {
  background: whitesmoke;
  color: rgba(16, 16, 16, 1);
}

.options ul li.selected {
  background: whitesmoke;
  color: rgba(16, 16, 16, 1);
}

.btn-search {
  border-radius: 4px;
  width: 100%;
  background-color: rgba(48, 107, 221, 1);
  color: white;
}

.btn-search:hover {
  border-radius: 4px;
  width: 100%;
  background-color: rgba(48, 107, 255, 1);
  color: white;
}

.btn-add {
  border-radius: 4px;
  width: 100%;
  border: 1px solid rgba(48, 107, 221, 1);
  background-color: white;
  color: rgba(16, 16, 16, 1);
  font-weight: 500;
  font-size: 14px;
}

.btn-add:hover {
  border-radius: 4px;
  width: 100%;
  border: 1px solid rgba(48, 107, 221, 1);
  background-color: rgba(48, 107, 221, 1);
  color: white;
}

.btn-cancel {
  border-radius: 4px;
  width: 200px;
  float: left;
  border: 1px solid rgba(48, 107, 221, 1);
  background-color: white;
  color: rgba(16, 16, 16, 1);
  font-weight: 500;
  font-size: 14px;
}

.btn-cancel:hover {
  border-radius: 4px;
  width: 200px;
  float: left;
  border: 1px solid rgba(48, 107, 221, 1);
  background-color: rgba(48, 107, 221, 1);
  color: white;
}

.reloadOn {
  float: left;
  cursor: pointer;
  transform: rotate(-180deg);
  transition: 300ms linear all;
}

.reloadOff {
  float: left;
  cursor: pointer;
  transform: rotate(180deg);
  transition: 300ms linear all;
}

div.search-area {
  padding-top: 12px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 6px !important;
  background-color: white;
  z-index: 1;
}

div.sticky1 {
  position: -webkit-sticky;
  position: sticky;
  top: 54px;
  padding-top: 6px;
  padding-right: 20px;
  padding-left: 20px;
  padding-bottom: 12px !important;
  background-color: white;
  z-index: 1;
}

input {
  background-color: rgba(249, 250, 252, 1);
}

.area-edit {
  background-color: white;
  border-bottom: 1px solid rgba(238, 238, 238, 1);
}

.area-back {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 8px;
  padding-bottom: 8px;
}

.area-input {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 8px;
  padding-bottom: 8px;
}

.area-input label {
  font-size: 12px;
  color: rgba(154, 154, 154, 1);
  font-weight: 600;
  margin-bottom: 12px;
}

.area-input input, .area-input .model-select {
  background-color: white;
  margin-bottom: 20px;
}

.area-button-submit {
  padding-left: 20px;
  padding-bottom: 20px;
  padding-top: 32px;
}

.select-invalid {
  border: 1px solid #e55353 !important;
}

.select-valid {
  border: 1px solid #2eb85c !important;
}

.btn-edit-submit {
  border-radius: 4px;
  float: left;
  width: 200px;
  background-color: rgba(48, 107, 221, 1);
  color: white;
  font-size: 14px;
}

.cards-image {
  position: absolute;
  text-align: center;
  font-size: 27px;
  color: rgba(96, 96, 96, 1);
  line-height: 50px;
  border: 1px dotted rgba(221, 221, 221, 1);
  width: 56px !important;
  background-color: rgba(250, 250, 250, 1);
  height: 56px !important;
}

input[type="checkbox"] {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
</style>
